import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth, isStaff } from "@/lib/auth";

export function ProtectedRoute({ children, staffOnly = false }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="tech-label">a carregar…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  if (staffOnly && !isStaff(user)) return <Navigate to="/portal" replace />;
  return children;
}
